export const enumPermisosPowwi = Object.freeze({
  powwi_retiros: 31002,
  powwi_depositos: 31001,
});
